export default {
  toasts: {
    failed_to_create_website: 'Websitet kunne ikke oprettes',
  },
  steps: {
    information: 'Oplysninger',
    template: 'Skabelon',
  },
  buttons: {
    next: 'Næste',
    previous: 'Forrige',
    create_website: 'Opret website',
    preview_about_us: 'Om os (forhåndsvisning)',
  },
  about_us_modal: {
    title: 'Om os (forhåndsvisning)',
  },
  error_messages: {
    missing_fields: 'Nogle obligatoriske felter mangler. Udfyld alle nødvendige oplysninger, før du fortsætter.',
  },
};
